module.exports = __webpack_public_path__ + "img/appointmentLoginIcon.efc59d71.png";